import { render, staticRenderFns } from "./DataManage.vue?vue&type=template&id=1314d5d2&scoped=true"
import script from "./DataManage.vue?vue&type=script&lang=js"
export * from "./DataManage.vue?vue&type=script&lang=js"
import style0 from "./DataManage.vue?vue&type=style&index=0&id=1314d5d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1314d5d2",
  null
  
)

export default component.exports